/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const arrow_right_medium = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M2.25 12H22.5M15 19.5l7.5-7.5m0 0L15 4.5"
    />
  </svg>
)
export default arrow_right_medium
